export * from './response-versioned.config';
